var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounSavings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4359 19.2169V17.0569C22.4359 16.2569 23.0759 15.6169 23.8759 15.6169H25.5559V13.0569C25.5559 12.0169 24.7559 11.2169 23.7159 11.2169H22.8359V9.85686C22.8359 8.73686 21.9559 7.77686 20.7559 7.77686H7.55586C6.43586 7.77686 5.47586 8.65686 5.47586 9.85686V23.2169C5.47586 24.2569 6.27586 25.0569 7.31586 25.0569H23.7159C24.7559 25.0569 25.5559 24.2569 25.5559 23.2169V20.5769H23.8759C23.0759 20.6569 22.4359 20.0169 22.4359 19.2169ZM21.8759 11.2169H7.63586C6.99586 11.2169 6.43586 10.6569 6.43586 10.0169C6.43586 9.37686 6.99586 8.81686 7.63586 8.81686H20.8359C21.3959 8.81686 21.8759 9.29686 21.8759 9.85686V11.2169Z",
    fill: "#A603F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2758 16.0969H24.2758C23.5558 16.0969 22.9958 16.6569 22.9958 17.3769V18.8169C22.9958 19.5369 23.5558 20.0969 24.2758 20.0969H26.2758C26.9958 20.0969 27.5558 19.5369 27.5558 18.8169V17.3769C27.5558 16.6569 26.9958 16.0969 26.2758 16.0969Z",
    fill: "#A603F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounSavings);
export default __webpack_public_path__ + "static/media/noun-savings.905e6c479bf03a7e58f97feae25ea9a7.svg";
export { ForwardRef as ReactComponent };